class Service {
    public version = '';
    public service = '';
    public specification = '';
    public environment = '';
}

export default Service;
